import React from "react";
import { Col, Row } from "reactstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import Alert from "sweetalert2";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import constantURI from "../URI"
import _post from "../Functions/Post"
import SearchFilterFunction from "../Functions/SearchFilter"
import stylesMed from "./stylesMed"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class Calendar extends React.Component {

    constructor() {
        super();
        this.state = {
            myEvents: [],
            events: [],
            clients: [],
            eventsCopy: [],
            user: "",
            token: [],
            currentRep: [],
            loading: true,
            selectedClients: [],
            disableSave: false,
            selectedRep: "",
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const token = JSON.parse(localStorage.getItem('Token'));
        const selectedRep = JSON.parse(localStorage.getItem('SelectedRep'));
        await this.setState({ token: token, selectedRep: selectedRep });

        if (this.state.selectedRep !== "") {
            this.setState({ user: this.state.selectedRep });
        }
        else {
            const user = JSON.parse(localStorage.getItem('User'));
            await this.setState({ user: user });
        }

        const clientsURL = constantURI() + "odooController/MedRepRead";
        const clientsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "res.partner",
                args: [],
                kwargs: {
                    fields: ["name", "state_id"],
                    domain: [["x_repuser", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const rep = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(clientsURL, clientsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ clients: data.result });
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(clientsURL, rep).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ currentRep: data.result })
                        localStorage.setItem('UserDetail', JSON.stringify(this.state.currentRep));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const clients = localStorage.getItem('HCPs');
            const currentRep = localStorage.getItem("UserDetail");
            await this.setState({ clients: clients, currentRep: JSON.parse(currentRep) });
        }

        await this.state.clients.forEach(obj => this.renameKey(obj, 'name', 'title'));
        await this.state.clients.forEach(obj => this.renameKey(obj, 'id', 'ID'));

        await this.state.clients.forEach((item, index) => {
            item.id = index;
            item.backgroundColor = "orange";
        })

        await this.setState({ events: this.state.clients, eventsCopy: this.state.clients });
        await this.fetchVisits();

        let draggableEl = document.getElementById("external-events");
        new Draggable(draggableEl, {
            itemSelector: ".fc-event",
            eventData: function (eventEl) {
                let title = eventEl.getAttribute("title");
                let id = eventEl.getAttribute("data");
                return {
                    title: title,
                    id: id,

                };
            }
        });
    }

    onSave = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        this.setState({ loading: true, disableSave: true });
        const createVisitURL = constantURI() + "/OdooController/CreateVisit";
        const d = new Date();
        d.setDate(d.getDate());
        if (this.state.selectedClients.length !== 0) {
            this.state.selectedClients.map(async (item, index, arr) => {
                const visitBody = {
                    jsonrpc: "2.0",
                    params: {
                        method: "create",
                        model: "calendar.event",
                        args: [
                            {
                                name: this.state.eventsCopy[index].title + "-" + this.state.eventsCopy[index].state_id[1] + " (" + this.state.user + ")",
                                start: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }),
                                start_date: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }),
                                start_datetime: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }) + " " + d.toISOString().substring(11, 19),
                                stop: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }),
                                stop_date: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }),
                                stop_datetime: item.start.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }) + " " + d.toISOString().substring(11, 19),
                                duration: 0.00,
                                x_status: "4",
                                partner_ids: [this.state.eventsCopy[index].ID, this.state.currentRep[0].id]
                            }
                        ],
                        "kwargs": {}
                    },
                    "token": this.state.token
                }
                console.log(JSON.stringify(visitBody));
                if (this.state.authenticate) {
                    await _post(createVisitURL, visitBody).then(async () => {
                        if (index === arr.length - 1) {
                            this.fetchVisits();
                        }
                    })
                }
            })
        }
    }

    fetchVisits = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const clientsURL = constantURI() + "odooController/MedRepRead";
        const visitsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "calendar.event",
                args: [],
                kwargs: {
                    fields: ["name", "start_datetime", "stop_datetime", "x_status"],
                    domain: [["partner_ids", "=", this.state.user], ["x_status", "<", "9"]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(clientsURL, visitsBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ visits: data.result, loading: false });
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }

        else {
            const visits = localStorage.getItem('CalendarVisits');
            await this.setState({ visits: visits, loading: false });
        }

        await this.state.visits.forEach(obj => this.renameKey(obj, 'name', 'title'));
        await this.state.visits.forEach(obj => this.renameKey(obj, 'start_datetime', 'start'));
        await this.state.visits.forEach(obj => this.renameKey(obj, 'stop_datetime', 'end'));
        await this.state.visits.forEach((obj) => {
            if (obj.x_status === "0") {
                obj.color = "white";
            }
            else if (obj.x_status === "1") {
                obj.color = "green";
            }
            else if (obj.x_status === "2" || obj.x_status === "3") {
                obj.color = "red";
            }
        })
        this.setState({ myEvents: this.state.visits, disableSave: false, events: this.state.eventsCopy });
        localStorage.setItem('CalendarVisits', JSON.stringify(this.state.myEvents));
    }

    renameKey = (obj, oldKey, newKey) => {
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.events, this.state.eventsCopy, this.state.noData);
        this.setState({ events: values.items, noData: values.noData })
    }

    eventClick = eventClick => {
        if (eventClick.event._def.extendedProps.x_status === undefined) {
            Alert.fire({
                title: eventClick.event.title,
                html:
                    `<div class="table-responsive">
      <table class="table">
      <tbody>
      <tr >
      <td>Title</td>
      <td><strong>` +
                    eventClick.event.title +
                    `</strong></td>
      </tr>
      <tr >
      <td>Start Time</td>
      <td><strong>
      ` +
                    eventClick.event.start +
                    `
      </strong></td>
      </tr>
      </tbody>
      </table>
      </div>`,

                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Remove Event",
                cancelButtonText: "Close"
            }).then(result => {
                if (result.value) {
                    eventClick.event.remove();
                    Alert.fire("Deleted!", "Your Event has been deleted.", "success");
                }
            });
        }
    };

    eventReceive = (event) => {
        var temp = this.state.selectedClients;
        temp[event.event.id] = event.event;
        this.setState({ selectedClients: temp });
    }

    render() {
        if (!this.state.loading && this.state.user !== "") {
            return (
                <div className="animated fadeIn demo-app">
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="col m-1 d-flex flex-row-reverse">
                        <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save Route</div>
                    </div>
                    <Row>
                        <Col lg={3} sm={3} md={3}>
                            <div
                                id="external-events"
                                style={{
                                    width: "100%",
                                    height: 700
                                }}
                            >
                                <input type="text" className="form-control" style={{ width: "100%" }} placeholder="Search Here" onChange={text => this.onSearch(text)} />
                                {this.state.events.map(event => (
                                    <div
                                        className="fc-event"
                                        title={event.title}
                                        data={event.id}
                                        key={event.id}
                                        style={{ borderRadius: 5, padding: 5, color: "white" }}
                                    >
                                        {event.title}
                                    </div>
                                ))}
                            </div>
                        </Col>

                        <Col lg={9} sm={9} md={9}>
                            <div className="demo-app-calendar" id="mycalendartest">
                                <FullCalendar
                                    defaultView="dayGridMonth"
                                    header={{
                                        left: "prev,next",
                                        center: "title",
                                        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                                    }}
                                    rerenderDelay={10}
                                    eventDurationEditable={false}
                                    editable={false}
                                    droppable={true}
                                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                    events={this.state.myEvents}
                                    eventClick={this.eventClick}
                                    eventReceive={this.eventReceive}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
